// import PropTypes from 'prop-types';
import Popup from '@scandipwa/scandipwa/src/component/Popup';
import { REVIEW_POPUP_ID } from 'Component/ProductReviews/ProductReviews.config';
import React, { PureComponent } from 'react';
import freegift from "../../assets/freegift.png";
import './FreeGiftOption.style';

export class FreeGiftOption extends PureComponent {
    static propTypes = {

    };

    state = {
        optionGiftDetails: false,
        exapanded: false
    }

    openFreeGiftdetails = () => {
        const { optionGiftDetails } = this.state;
        console.log("fdke");
        var htmlTag = document.documentElement;
        htmlTag.classList.toggle('scrollDisabled');

        this.setState({ optionGiftDetails: !optionGiftDetails })
    }

    render() {
        const { optionGiftDetails, exapanded } = this.state;
        const className = exapanded ? "exapanded" : ""

        return (
            <>
                <div className="FreeGiftOption" onClick={() => this.openFreeGiftdetails()}>
                    <div className="FreeGiftOption-promo-container">
                        <img src={freegift} alt="Earring Icon 2" />
                        <div className='FreeGiftOption-PromoSection'>
                            <span className='Section-Title'>Free Gift!</span>
                            <div>
                                <p>1/4 Carat Studs (value $300) With Purchase Over $1500.</p>
                                <p>1/2 Carat Studs (value $500) With Purchase Over $3500. </p>
                                <p>1 Carat Studs (value $750) With Purchase Over $5000. </p>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    optionGiftDetails && <Popup
                        id={"FreeGiftOption"}
                        mix={{ block: 'FreeGiftOption', elem: 'Popup' }}
                    >
                        <div className="modal-content">
                            <span onClick={() => this.openFreeGiftdetails()} className="close">&times;</span>
                            <div className="modal-section">
                                <img src={freegift} alt="Earrings" />
                                <div>
                                    <h3>Gorgeous Diamond Earrings Promotion</h3>
                                    <h2>FREE DIAMOND STUDS ON PURCHASES ABOVE $1500, $3500 and $5000.</h2>
                                    <p>Receive a beautiful set of 1/4 ctw Stud Earrings in 14k White Gold as a complimentary gift for eligible orders over $1500 (value $300). Over $3500 will receive 1/2 ctw Diamond Earrings in 14k White Gold (value $500) and those spending Over $5000 will receive 1.00 ctw Diamond Earrings in 14K White Gold (value $750).</p>
                                    <p>Hurry - offer available for a limited time! Only one complimentary set per transaction.</p>
                                    <div className={`termsandcondititon ${className}`}>
                                        <p>
                                            <strong>Terms & Conditions:</strong> Offer is exclusively for purchases over $1500 (before tax) and cannot be combined with other offers. Applicable for orders made post on June 28, 2024. It cannot be retroactively applied to prior purchases. This promotion cannot be combined with other discounts, applies to all customers, and limits one pair of studs per customer. The provided earrings are detailed below:
                                        </p>
                                        <p>Lab Grown Diamond Stud Earrings set in 14K White Gold.</p>
                                        <p>Limited stock available, and offer valid until stocks last. Earrings are non-returnable, non-refundable, and not replaced if lost or stolen. If items are returned resulting</p>
                                        <p>Guidelines for Returns and Exchanges</p>
                                        <p>Products that have not been worn and remain in their original condition are eligible for return or exchange, and they must include the complimentary gift.</p>
                                        <p>Customers who wish to retain the complimentary gift will have its value subtracted from the total purchase cost as listed above.</p>
                                        <span onClick={() => this.setState({ exapanded: true })} className='read-more'>... read more</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Popup>
                }
            </>
        );
    }
}

export default FreeGiftOption;
